
export default {

    "title": "Protocol",
    "entityName": "protocol",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    filterStorage: {},
    "fields": [
        {
            slim:true,
            value: "name",
            text: "Name",
            type: "text",
            table: {
                sortable: true,
                filter: true
            },
            validators: [
                "required"
            ]
        },
        {
            slim:true,
            value: "sponsor_id",
            text: "Sponsor",
            type: "autocomplete",
            "id":"id",
            "item-id": "id",
            "item-text": "name",
            "title": "name",
            table: { "filter": true },
            validators: [
                "required"
            ],
            render: (item) => {
                return item.sponsor.name
            }
        },
        {
            slim:true,
            "value": "provider",
            "text": "Provider",
            "type": "list",
            "list" : ['REDCap', 'Emntg', 'Heads', 'Medidata', 'MM-sen', 'Opis', 'RealMM'],
            "table": { "filter": true },
            "validators": [
                // "required"
            ]
        },

        {
            slim:true,
            "value": "map_name",
            "text": "External Name",
            "type": "text",
            "validators": [
                // "required"
            ]         
        },

        {
            slim:true,
            value: "arms_r1",
            text: "Arms Random1",
            append_icon: '',
            multiple: true,
            chips: true,
            deletable_chips:true,
            items:[],
            placeholder: '',
            loadRemote: false,
            type: "combobox",
        },

         {
            slim:true,
            value: "arms_r2",
            text: "Arms Random2",
            append_icon: '',
            multiple: true,
            chips: true,
            deletable_chips:true,
            items:[],
            placeholder: '',
            loadRemote: false,
            type: "combobox",
        },

         {
            slim:true,
            value: "arms_r3",
            text: "Arms Random3",
            append_icon: '',
            multiple: true,
            chips: true,
            deletable_chips:true,
            items:[],
            placeholder: '',
            loadRemote: false,
            type: "combobox",
        },

         {
            slim:true,
            value: "arms_r4",
            text: "Arms Random4",
            append_icon: '',
            multiple: true,
            chips: true,
            deletable_chips:true,
            items:[],
            placeholder: '',
            loadRemote: false,
            type: "combobox",
        },


        {
            slim:true,
            "value": "status",
            "text": "Status",
            "type": "list",
            "list": ["Open", "Closed", "Draft"],
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ]
        },

        {
            slim:true,
            value: "co_sponsors",
            text: "Co Sponsors",
            append_icon: '',
            multiple: true,
            chips: true,
            deletable_chips:true,
            list:['EMN'],
            placeholder: '',
            loadRemote: false,
            type: "list",
        },


        {
            value: "sync_with",
            text: "Sync With / Available platforms",
            multiple: true,
            chips: true,
            deletable_chips:true,
            list:['SafetyDB', 'eCDS', 'EMN Logistic', 'REDCap', 'eTMF'],
            placeholder: '',
            loadRemote: false,
            type: "list",
            readonly: item => item.sponsor_id == -1
        },

        // {
        //     full:true,
        //     value: "available_roles",
        //     text: "Available User Roles",
        //     multiple: true,
        //     chips: true,
        //     deletable_chips:true,
        //     items:[
        //         'Principal Investigator (PI)', 'Sub-Investigator (SI)', 'Data-Manager (DM)', 'Pharmacist', 'FISH lab user', 'NGF lab user', 'FISH and NGF lab user', 'Supervisor FISH', 'Supervisor NGF', 'Supervisor FISH and NGF','Monitor', 'Statistician', 'Read only'        
        //       ],
        //     placeholder: '',
        //     loadRemote: false,
        //     type: "combobox",
        // },

        {
            full:true,
            value: "account_activators",
            text: "User Activators",
            multiple: true,
            chips: true,
            items:[],
            deletable_chips:true,
            placeholder: '',
            loadRemote: true,
            type: "autocomplete",
            id:"id",
            subtitle:"email",
            reference: "account",
            default: () => undefined,
            filter: (item, search) => { return { urs : [{ 'first_name': `%${search}%`}, { 'last_name': `%${search}%`}, { 'email': `%${search}%`}], 'role':`Administrator`, 'status' : 'Active'} },
            title: (item) => item.first_name + ' ' + item.last_name
        },

        {
            full:true,
            value: "email_activators",
            text: "User Activators Emails",
            multiple: true,
            chips: true,
            items:[],
            deletable_chips:true,
            placeholder: '',
            loadRemote: false,
            type: "combobox",
        },


        // {
        //     "value": "n_patients",
        //     "text": "N. max patients",
        //     "type": "number",
        //     "table": {
        //         "sortable": true,
        //         "filter": true
        //     },            
        //     "validators": [
        //         "required",
        //         "number"
        //     ]
        // },
          
    ],
    "actions": [
        { "value": "new_user_survey", "text": "Open user survey", "icon": "mdi-open-in-new", "color": "primary" },
        { "value": "edit", "text": "Edit", "icon": "mdi-pencil", "color": "primary" },
        "remove", "audit_trail"
        // 
    ]
}